import React from 'react'
import { Box, Card, CardContent, Typography } from '@mui/material'
import notFoundSvg from '../../assets/images/file-missing-close.svg'
import CenteredCardLayout from '../../layouts/centered-card-layout'

const NotFoundPage: React.FC = () => {
  return (
    <CenteredCardLayout addPadding>
      <Card
        variant='outlined'
        sx={{
          width: 'fit-content',
          padding: 2,
          borderRadius: 0,
        }}
      >
        <CardContent
          sx={{
            height: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box>
            <img src={notFoundSvg} alt='Page Not Found' style={{ height: '128px' }}/>
          </Box>
          <Typography align='center' pt={4}>
            The page you&apos;re looking for does not exist.
          </Typography>
        </CardContent>
      </Card>
    </CenteredCardLayout>
  )
}

export default NotFoundPage
